export const getTimeZone = (anonymityInfo) => {
  const zone = anonymityInfo?.data?.gmt;

  const offsetOperator = Math.sign(zone) === 1 ? "+" : "";

  return `${offsetOperator}${zone}`;
};
